import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Button, SelectableOptionGroup, SelectListGroup } from "../../common";
import * as style from "./styles.module.scss";

const DocumentType = ({
  setStep,
  idType,
  studentPermissions,
  courseCompleted,
  documents,
  rightToWorkFiles,
  handleChange,
  jobId,
  findStep,
}) => {
  const options = documents.map(({ value, label }) => ({
    value,
    label,
  }));

  const hasFailedYoti = [...(rightToWorkFiles || [])].find(
    ({ TypeCode }) => TypeCode === "YRTF"
  );

  const nextButtonDisabled = () => {
    if (idType && idType !== "shareCode") {
      return false;
    }

    if (
      idType &&
      idType === "shareCode" &&
      (studentPermissions === false ||
        (studentPermissions === true && courseCompleted !== null))
    ) {
      return false;
    }

    return true;
  };

  const shareCodeNextStep = () => {
    if (studentPermissions && courseCompleted) {
      return setStep("studentCompleted");
    }
    if (studentPermissions && !courseCompleted) {
      return setStep("student");
    }
    return setStep(1);
  };

  const nextStep = () => {
    switch (idType) {
      case "passport":
        setStep("yoti");
        break;
      case "shareCode":
        shareCodeNextStep();
        break;
      default:
        setStep(1);
    }
  };

  return (
    <Fragment>
      <div className={`mb-3`}>
        {hasFailedYoti && (
          <p>
            <strong>
              Unfortunately, we were not able to verify your Right to Work
              document. Please either try again, or contact your local branch to
              discuss next steps.
            </strong>
          </p>
        )}
        <div className="mb-2">
          This information will be shared with any one of our partners that you
          work with when contracted to HRGO for auditing purposes and so that
          they can verify your right to work in the UK.
        </div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label htmlFor="title">Right to work document type</label>
              <SelectListGroup
                id="idType"
                value={idType}
                onChange={(e) => {
                  handleChange("idType", e.target.value);
                }}
                options={[
                  { label: "-- Please select --", value: "" },
                  ...options,
                ]}
                classes="register_field register_field-dropdown cursor-pointer"
              />
            </div>
          </div>
        </div>
        {idType === "passport" && (
          <div style={{ padding: "0.2rem" }}>
            Our partners at Yoti will do an automated Right to Work ID check.
            They recommend using your mobile phone and either Chrome, Safari or
            Edge browser for the best experience.
          </div>
        )}
        {idType === "shareCode" && (
          <Fragment>
            <div className="mt-2 mt-sm-1">
              <label htmlFor="studentPermissions">
                Will your share code confirm student permissions of 20 hours per
                week during term time?
              </label>
              <div className="form-group">
                <SelectableOptionGroup
                  selectedOption={studentPermissions ? "yes" : "no"}
                  handleOptionChange={(e) => {
                    handleChange(
                      "studentPermissions",
                      e.target.value === "yes"
                    );
                  }}
                  options={[
                    { value: "no", label: "No" },
                    { value: "yes", label: "Yes" },
                  ]}
                  name="studentPermissions"
                />
              </div>
            </div>
            {studentPermissions && (
              <div className="mt-2 mt-sm-1">
                <label htmlFor="courseCompleted">
                  Have you completed your course?
                </label>
                <div className="form-group">
                  <SelectableOptionGroup
                    selectedOption={courseCompleted ? "yes" : "no"}
                    handleOptionChange={(e) => {
                      handleChange("courseCompleted", e.target.value === "yes");
                    }}
                    options={[
                      { value: "no", label: "No" },
                      { value: "yes", label: "Yes" },
                    ]}
                    name="courseCompleted"
                  />
                </div>
              </div>
            )}
          </Fragment>
        )}
      </div>
      <div className={`mt-lg-auto mb-lg-2 ${style.actions}`}>
        <Link to={findStep("health-and-disability", jobId)}>
          <button className="btn btn-outline-info text-dark mr-1" type="button">
            Back
          </button>
        </Link>
        <Button
          id="document-type-next-button"
          classes="btn btn-primary btn-block"
          onClick={() => nextStep()}
          disabled={nextButtonDisabled()}
        >
          Next
        </Button>
      </div>
    </Fragment>
  );
};

export default DocumentType;
